import { policyTextForEditor, resolvePolicyDisplayHtml } from './policyContentHtml';

/** Plain text length after stripping tags (for previews and validation). */
export function stripRichTextToPlain(html: string | null | undefined): string {
  if (!html) return '';
  const withoutTags = html.replace(/<[^>]+>/g, ' ');
  const decoded = withoutTags
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"');
  return decoded.replace(/\s+/g, ' ').trim();
}

export function isRichTextEmpty(html: string | null | undefined): boolean {
  return stripRichTextToPlain(html).length === 0;
}

/** HTML safe for listing description display (legacy plain text supported). */
export function resolveListingDescriptionHtml(description: string | null | undefined): string {
  return resolvePolicyDisplayHtml(description);
}

/** Value for Quill when editing an existing listing description. */
export function listingDescriptionForEditor(description: string | null | undefined): string {
  return policyTextForEditor(description);
}
